const MENU_CACHE_KEY = 'Training-Menu-Tree'
let cachedMenus = null

function canUseStorage() {
  return typeof window !== 'undefined' && window.localStorage
}

export const menuCache = {
  save(menus) {
    cachedMenus = menus
    if (canUseStorage()) {
      try {
        window.localStorage.setItem(MENU_CACHE_KEY, JSON.stringify(menus || []))
      } catch (e) {
        // ignore storage failures
      }
    }
  },
  get() {
    if (Array.isArray(cachedMenus) && cachedMenus.length > 0) {
      return cachedMenus
    }
    if (canUseStorage()) {
      try {
        const raw = window.localStorage.getItem(MENU_CACHE_KEY)
        if (raw) {
          const parsed = JSON.parse(raw)
          cachedMenus = Array.isArray(parsed) && parsed.length > 0 ? parsed : null
        }
      } catch (e) {
        cachedMenus = null
      }
    }
    return cachedMenus
  },
  clear() {
    cachedMenus = null
    if (canUseStorage()) {
      try {
        window.localStorage.removeItem(MENU_CACHE_KEY)
      } catch (e) {
        // ignore storage failures
      }
    }
  }
}
